// extracted by mini-css-extract-plugin
export default {"tool-wrap":"tool-wrap-zMBj1I"};